module.exports = "<div>\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.html
// module id = ./src/app/login/login.html
// module chunks = main